import React from 'react';
import { ChevronRight } from 'lucide-react';

export const ServiceCard = ({ icon, title, description }) => (
  <div className="bg-white p-6 rounded-lg shadow-md hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2 animate-slideUp">
    <div className="text-primary mb-4">{icon}</div>
    <h3 className="text-xl font-bold mb-2 text-gray-800">{title}</h3>
    <p className="text-gray-600">{description}</p>
    <button className="mt-4 text-primary font-medium flex items-center group">
      Learn More 
      <ChevronRight className="w-4 h-4 ml-1 group-hover:translate-x-2 transition-transform duration-300" />
    </button>
  </div>
);

export const FeatureCard = ({ icon, title, description }) => (
  <div className="text-center p-6 animate-fadeIn hover:bg-secondary rounded-lg transition-colors duration-300">
    <div className="text-primary w-12 h-12 mx-auto mb-4 flex items-center justify-center animate-bounce">
      {icon}
    </div>
    <h3 className="text-xl font-bold mb-2 text-gray-800">{title}</h3>
    <p className="text-gray-600">{description}</p>
  </div>
);

export const TestimonialCard = ({ text, author }) => (
  <div className="bg-white p-6 rounded-lg shadow-md hover:shadow-xl transition-all duration-300 animate-slideIn">
    <p className="text-gray-600 mb-4 italic">"{text}"</p>
    <p className="font-medium text-primary">- {author}</p>
  </div>
);